import http from "@/http-common";

class AbsentLetterConfigService {
    async get() {
        return await http.get("/config-school");
    }

    update(data) {
        return http.put(`/config-school`, data);
    }
}

export default new AbsentLetterConfigService();